var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"bg-red-200 border-2 border-red-300 text-sm text-red-600 px-4 py-3 rounded-xs relative mb-3",attrs:{"role":"alert"}},[_c('span',{staticClass:"block sm:inline"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }